import { render, staticRenderFns } from "./reminders.vue?vue&type=template&id=053c7fd3&"
import script from "./reminders.vue?vue&type=script&lang=js&"
export * from "./reminders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports